import { useBondsBondFieldApi } from '../api';

export const useBondsBondSAccOblFirstCps = () => {
  const response = useBondsBondFieldApi('S_ACC.OBL_FIRST_CPS');
  return response;
};
